var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("VDataTable", {
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          pagination: _vm.pagination,
          "hide-actions": "",
          loading: _vm.loading,
          expand: _vm.expandAll,
          "item-key": _vm.itemKey
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "progress",
              fn: function() {
                return [
                  _c("VProgressLinear", {
                    attrs: { color: "#333", indeterminate: "" }
                  })
                ]
              },
              proxy: true
            },
            {
              key: "items",
              fn: function(slotItemsProps) {
                return [
                  _vm._t(
                    "item",
                    [
                      _c(
                        "tr",
                        {
                          on: {
                            click: function($event) {
                              return _vm.handleRowClick(slotItemsProps)
                            }
                          }
                        },
                        _vm._l(Object.keys(slotItemsProps.item), function(
                          i,
                          itemIndex
                        ) {
                          return _c(
                            "td",
                            {
                              key: itemIndex,
                              class: {
                                "action-container":
                                  itemIndex ===
                                    Object.keys(slotItemsProps.item).length -
                                      1 && _vm.$slots.actions
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(slotItemsProps.item[i]) +
                                  "\n            "
                              ),
                              itemIndex ===
                                Object.keys(slotItemsProps.item).length - 1 &&
                              _vm.$slots.actions
                                ? _c(
                                    "span",
                                    { staticClass: "actions" },
                                    [_vm._t("actions")],
                                    2
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      )
                    ],
                    { itemProps: slotItemsProps }
                  )
                ]
              }
            },
            {
              key: "expand",
              fn: function(ref) {
                var index = ref.index
                var item = ref.item
                var expanded = ref.expanded
                return [
                  _vm._t("expandedContent", null, {
                    content: { index: index, item: item, expanded: expanded }
                  })
                ]
              }
            }
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-md-right text-xs-center" },
        [
          _c("VPagination", {
            attrs: { length: _vm.pages },
            model: {
              value: _vm.pagination.page,
              callback: function($$v) {
                _vm.$set(_vm.pagination, "page", $$v)
              },
              expression: "pagination.page"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }